query TransactionsChartData {
  kpiTransactionTypes {
    nodes {
      title
      amount
      linkSearchValue
    }
  }
}
